import React from "react";

const Navbar: React.FC = () => {
  return (
    <div className="navbar navbar-default navbar-lg header-highlight">
      <div className="navbar-header">
        <a className="navbar-brand" href="index.html">
          <i className="icon-rfm"></i>
        </a>

        <ul className="nav navbar-nav pull-right visible-xs-block">
          <li>
            <a data-toggle="collapse" data-target="#navbar-mobile" href="/">
              <i className="icon-tree5"></i>
            </a>
          </li>
          <li>
            <a className="sidebar-mobile-main-toggle">
              <i className="icon-paragraph-justify3"></i>
            </a>
          </li>
          <li>
            <a className="sidebar-mobile-detached-toggle" href="/">
              <i className="icon-grid7"></i>
            </a>
          </li>
        </ul>
      </div>

      <div className="navbar-collapse collapse" id="navbar-mobile">
        <ul className="nav navbar-nav">
          <li>
            <a className="sidebar-control sidebar-main-hide hidden-xs">
              <i className="icon-paragraph-justify3"></i>
            </a>
          </li>
        </ul>

        {/* <ul className="nav navbar-nav navbar-right">
          <li>
            <a href="other_changelog.html#roadmap.html">Roadmap</a>
          </li>
          <li>
            <a href="other_changelog.html">
              Changelog{" "}
              <span className="label label-inline bg-warning-400 position-right">
                v. 1.3
              </span>
            </a>
          </li>
        </ul> */}
      </div>
    </div>
  );
};

export default Navbar;
